import ProgressModel from "../ProgressModel.vue";

export default {
    components:{
        ProgressModel
    },
    data() {
        return {
            clear_loading: false,
            masks: {
                creditMask: "credit-card",
                socialMask: "social",
                phoneMask: "phone",
                zipMask: "#####",
                routingMask: "#########",
                taxIDmask: "##-#######",
                percentMask: "###",
                creditScoreMask: "###",
                monthYearMask: "##/####",
                sicCodeMask: "##-##",
                socialSecurityMask: " ###-##-####"
            },
            emailRules: [
                v => !!v || 'E-mail is required',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
            ],
            states: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'],

        }
    },
    methods: {
        async updateSubmissionById(data) {
            return await this.$store.dispatch("deals/updateSubmission", data);
        },
        formatPrice(value) {
            if(Number.isNaN(value)){
                return 0.00;
            }
            let val = (value / 1).toFixed(2).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        async customAction(data) {
            return await this.$store.dispatch(data.url, data.paramsData);
        },
        updateInfo(value, dataKey, tableName, id){
          return this.$store.dispatch("deals/updateInfo", { id, value, dataKey, tableName });
        },
        flashDisplay(message, flash_type){
            this.flash(message, flash_type, {
                timeout: 3000
            });
        },
        redirectToSubmission({ unique_id, company_id }) {
            let route = this.$router.resolve({
              path: `submission/${unique_id}`,
              query: { companyId: company_id }
            });
            window.open(route.href, "_blank");
          },
        async claim_deal(data){
           return await this.$store.dispatch("deals/submissions/claimSubmission", data);
        },
        notificationAction(data, user_id, url){
            data.forEach(async(item, ind) => {
                item.read_by.push(user_id)
                await this.$store.dispatch(url, item);
            });
        },
        getName(item){
            let userInfo = JSON.parse(item.claimed_user);
            return userInfo.user_name
        },
        getNotifications(item){
            if(item.length > 0){
                item.forEach(i => {
                    i.read_by = i.read_by != null ? JSON.parse(i.read_by) : []
                })
            }
            return item;
        }
    },
    
}